module.exports = __webpack_public_path__ + "static/babyannouncevest-f9da2eb69bd63abad477dea3320e15a9.jpeg";